import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { callbackTypeEventRuleManageAdd, callbackTypeEventRuleManageUpd, conditionManageData, eventManageData, callbackSwitchConfigManageData, preConditionEventManageData } from "@/api/financial/backhaul";
import { serchSelect } from "@/mixins/index";
export default {
  mixins: [serchSelect],
  props: {
    callbackSwitchConfigData: {
      type: Array,
      data: function data() {
        return '';
      }
    },
    callbackEventReflectionManageDataList: {
      type: Array,
      data: function data() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      callbackSwitchConfigData: [],
      eventManageDataList: [],
      dialogFormVisible: false,
      conditionManageDataList: [],
      preDefineDataList: [],
      affiliationsList: [{
        label: "满足任一一个",
        value: "or"
      }, {
        label: "同时满足",
        value: "and"
      }],
      formData: {
        id: "",
        event_id: "",
        switch_config_id: '',
        rule: [],
        affiliations: ''
      },
      rules: {
        event_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        switch_config_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        field: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        rule: [{
          required: true,
          message: "请添加条件",
          trigger: "blur"
        }],
        operator: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        affiliations: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                _this.getconditionManageData();

                _this.getPreDefineData();

                if (row) {
                  data = _objectSpread({}, row);
                  data.rule = data.rule;
                  _this.formData = _objectSpread({}, data);

                  if (_this.formData.switch_config_id) {
                    _this.callbackSwitch(_this.formData.switch_config_id);
                  }

                  console.log("this.formData===", _this.formData);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    callbackSwitch: function callbackSwitch(e) {
      var _this2 = this;

      if (e == "") {
        this.eventManageDataList = [];
        this.formData.event_id = "";
        return;
      }

      var data = this.callbackSwitchConfigData.find(function (i) {
        return i.id == e;
      });
      eventManageData({
        advert_channel_id: data.advert_channel_id
      }).then(function (res) {
        // eventManageData({ advert_channel_id: e }).then(res => {
        if (res.status == 200) {
          _this2.eventManageDataList = res.data;
          var data1 = res.data.find(function (item) {
            return item.event_name == _this2.formData.event_name && item.advert_channel_id == _this2.formData.advert_channel_id;
          });

          if (!data1) {
            _this2.formData.event_id = "";
          }
        }
      });
    },
    addContent: function addContent() {
      this.formData.rule.push({
        field: '',
        operator: '',
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.rule.indexOf(item);

      if (index !== -1) {
        this.formData.rule.splice(index, 1);
      }
    },
    resetForm: function resetForm(formName) {
      this.formData.id = '';
      this.dialogFormVisible = false;
      this.clearData();
    },
    getPreDefineData: function getPreDefineData() {
      var _this3 = this;

      preConditionEventManageData().then(function (res) {
        if (res.status == 200) {
          _this3.preDefineDataList = res.data;
        }
      });
    },
    getconditionManageData: function getconditionManageData() {
      var _this4 = this;

      conditionManageData().then(function (res) {
        if (res.status == 200) {
          _this4.conditionManageDataList = res.data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this5 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this5.formData));
          var req = data.id ? callbackTypeEventRuleManageUpd : callbackTypeEventRuleManageAdd;
          req(data).then(function (res) {
            if (res.status == 200) {
              _this5.$Message.success('操作成功');

              _this5.$emit("refreshDataList");

              _this5.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      var _this6 = this;

      this.formData = {
        id: this.formData.id,
        event_id: "",
        switch_config_id: '',
        rule: [],
        affiliations: ''
      };
      this.$nextTick(function () {
        _this6.$refs.ruleForm.resetFields();
      });
    }
  }
};